export default __webpack_public_path__ + "static/media/Image_methode_étape2.69d0cae1.jpg";